import React from 'react';
import { customerSetoffService } from 'api/services';
import { useCustomerSetoffs } from 'hooks/api/useCommercial';
import PartySetoffScreen, { type PartySetoffConfig } from 'components/modules/accounts/setoff/PartySetoffScreen';

// Customer Set-off (ADR-0051 AR face, delivered by ADR-0060 slice 3): match a customer's CREDITS
// (on-account credit notes, advances) against its open invoices and short-paid items without
// moving money. Mark short-paid closes disputed invoices when no money arrives; each amount stays
// open on the customer's ledger as a short-paid item with its reason.
const CUSTOMER_SETOFF: PartySetoffConfig = {
  role: 'CUSTOMER',
  screenCode: 'customer-setoff',
  title: 'Customer Set-off',
  description: "Match a customer's credits against its invoices and short-paid amounts, or mark disputed invoices short-paid — no money moves (ADR-0051, ADR-0060)",
  service: customerSetoffService,
  useList: useCustomerSetoffs,
  partyType: 'CUSTOMER',
  partyWord: 'Customer',
  balanceSide: 'CR',
  balanceTitle: 'Credit balances',
  balanceHint: 'On-account credit notes and advances — what you owe the customer.',
  openTitle: 'Open debits',
  openHint: 'Invoices and short-paid amounts — what the customer owes you.',
  deductionWord: 'short-paid',
  markLabel: 'Mark short-paid',
  markHint: 'For invoices the customer disputes when no money has come in. Each invoice closes; the amount stays open on the customer\'s ledger as short-paid, with its reason, until it is received, set off against a credit note, or written off.',
};

interface CustomerSetoffScreenProps { moduleIcon?: string; tabId?: string; moduleName?: string; }

const CustomerSetoffScreen: React.FC<CustomerSetoffScreenProps> = (props) => <PartySetoffScreen config={CUSTOMER_SETOFF} {...props} />;

export default CustomerSetoffScreen;
